import React, { useMemo, useState } from "react";
import { DatePicker, Table } from "antd";
import dayjs from "dayjs";
import { Endpoints } from "../constants/endpoint.constant";
import { useGet } from "../hooks/useRest.hook";
import { formatDateTime, getInfringementActionLabel } from "../services/firestoreTracking.service";

function toQueryDate(value) {
  if (!value) return undefined;
  return dayjs(value).startOf("day").toISOString();
}

export const InfringementActionLogPanel = ({ provinceId = "all" }) => {
  const [dateRange, setDateRange] = useState([dayjs(), dayjs()]);
  const query = useMemo(() => ({
    provinceId: provinceId === "all" ? undefined : provinceId,
    fromDateTime: toQueryDate(dateRange?.[0]),
    toDateTime: toQueryDate(dateRange?.[1]),
  }), [provinceId, dateRange]);
  const logsRq = useGet(Endpoints.INFRINGEMENT_ACTION_LOGS, true, query);
  const summary = Array.isArray(logsRq?.data?.summary) ? logsRq.data.summary : [];
  const list = Array.isArray(logsRq?.data?.list) ? logsRq.data.list : [];

  return <div className="rounded-[28px] border border-[#ece5dd] bg-white px-6 py-6 shadow-[0_18px_55px_rgba(15,23,42,0.05)]">
    <div className="flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between">
      <div className="flex flex-col gap-2">
        <span className="text-[1.05rem] font-semibold text-[#161311]">Driver Action Log</span>
        <span className="text-sm text-[#6e6258]">Drivers reprimanded for speeding or offline infringements in the selected dates.</span>
      </div>
      <DatePicker.RangePicker value={dateRange} onChange={(value) => setDateRange(value || [dayjs(), dayjs()])} />
    </div>

    <div className="mt-5 grid grid-cols-1 gap-6 xl:grid-cols-2">
      <Table
        size="small"
        rowKey={(record) => record?.driverId || record?.driverName}
        loading={logsRq?.loading}
        pagination={{ pageSize: 5 }}
        dataSource={summary}
        locale={{ emptyText: "No drivers actioned in this date range." }}
        columns={[
          { title: "Driver", dataIndex: "driverName" },
          { title: "Total", dataIndex: "total" },
          { title: "Speeding", dataIndex: "speeding" },
          { title: "Offline", dataIndex: "offline" },
          { title: "Latest", dataIndex: "latestActionAtMs", render: formatDateTime },
        ]}
      />
      <Table
        size="small"
        rowKey={(record) => record?.id}
        loading={logsRq?.loading}
        pagination={{ pageSize: 5 }}
        dataSource={list}
        locale={{ emptyText: "No action notes in this date range." }}
        columns={[
          { title: "When", dataIndex: "createdAtMs", render: formatDateTime },
          { title: "Driver", dataIndex: "driverName" },
          { title: "Type", dataIndex: "infringementType" },
          { title: "Action", dataIndex: "actionType", render: getInfringementActionLabel },
          { title: "Note", dataIndex: "note" },
        ]}
      />
    </div>
  </div>;
};
